export const achievementLevelEnum = {
  SCHOOL_OF_LIFE: 'SCHOOL_OF_LIFE',
  LIBRARY_OF_KNOWLEDGE: 'LIBRARY_OF_KNOWLEDGE',
  HOUSE_OF_WISDOM: 'HOUSE_OF_WISDOM',
  MINISTRY_OF_FUTURE: 'MINISTRY_OF_FUTURE'
}

export const achievementLevels = Object.keys(achievementLevelEnum)

export const achievementLevelNumberPerLevelName = achievementLevels.reduce((acc, levelName, index) => {
  acc[levelName] = index + 1

  return acc
}, {})

export const achievementLevelNamePerLevelNumber = achievementLevels.reduce((acc, levelName, index) => {
  acc[index + 1] = levelName

  return acc
}, {})



// WEBPACK FOOTER //
// ./src/constants/achievement.js